import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { NavLink, generatePath } from 'react-router-dom';
import { ImageWithLoader, Carousel } from 'app/components';
import useTheme from 'app/hooks/useTheme';
import { FavoriteMovie, ShadowBoxDark, TitleAccent } from './styles';

const propTypes = {
  listContent: PropTypes.arrayOf(PropTypes.object).isRequired,
  routePattern: PropTypes.string.isRequired,
  sectionTitle: PropTypes.string.isRequired,
  noContent: PropTypes.func.isRequired,
  watchListBtn: PropTypes.func.isRequired
};

const carouselPropsConfig = tablet => ({
  slidesToSlide: 2,
  responsive: {
    tablet: {
      breakpoint: {
        max: 30000,
        min: tablet
      },
      items: 4
    },
    mobile: {
      breakpoint: {
        max: tablet,
        min: 0
      },
      items: 2
    }
  }
});

const CarouselWatchlist = ({ listContent, sectionTitle, noContent, routePattern, watchListBtn }) => {
  const theme = useTheme();
  const carouselProps = useMemo(
    () => carouselPropsConfig(parseInt(theme.breakPoints.sm.width, 10)),
    [theme]
  );

  return (
    <ShadowBoxDark>
      <TitleAccent>{sectionTitle}</TitleAccent>
      {listContent.length ? (
        <Carousel {...carouselProps}>
          {listContent.map(({ id, picture, title }) => (
            <FavoriteMovie key={id}>
              {watchListBtn(id)}
              <NavLink to={{ pathname: generatePath(routePattern, { id: title.split(" ").join("-") }), search: '?location=all' }}>
                <ImageWithLoader imgSrc={picture} imgTitle={title} />
              </NavLink>
            </FavoriteMovie>
          ))}
        </Carousel>
      ) :
        noContent()
      }
    </ShadowBoxDark>
  );
};

CarouselWatchlist.propTypes = propTypes;
export default CarouselWatchlist;
